'use client';

import { Button, Typography } from '@musinsa/mds';
import { useDeviceInfo } from '@musinsa/packages-device-detection';
import { twMerge } from 'tailwind-merge';
import { getPaths } from '../../common';
import { useNavigate } from '../../common/hooks';

interface EmptyCouponViewProps {
  shopSlug: string;
  isOwner: boolean;
  className?: string;
}

export const EmptyCouponView = ({ shopSlug, isOwner, className }: EmptyCouponViewProps) => {
  const { navigate } = useNavigate();
  const { service } = useDeviceInfo();
  const paths = getPaths(service);

  const handleGoToShop = () => {
    navigate(isOwner ? paths.myShop({ snsTitle: shopSlug }) : paths.shop({ snsTitle: shopSlug }));
  };

  return (
    <div
      className={twMerge(
        'flex grow flex-col items-center justify-center gap-3 bg-white px-4 pt-10',
        className,
      )}
    >
      <Typography variant="body14pxMed">진행 중인 큐레이터 쿠폰이 없습니다.</Typography>
      <Button variant="tertiaryOutlinedGray" className="h-6 px-1.5" onClick={handleGoToShop}>
        <Typography variant="body13pxMed" className="ml-0.5">
          큐레이터 샵 가기
        </Typography>
      </Button>
    </div>
  );
};
